
const defaultState = {
  loading: true,
  hasChanges: false,
  id: -1,
  sources: [],
  published: false,
  lawPlaces: [],
  showNewLawplaceDialog: false,
  organizations: [],
  allOrganizations: [],
  attachments: [],
  categoryPaths: [],
  autoCompleteCategories: [],
  filteredAutoCompleteCategories: [],
  publishedOnLoad: false,
  showFullTextUpload: true
};

export default (state = defaultState, action) => {

  switch (action.type) {
    case 'SBT_TOGGLE_SHOW_FULLTEXT_UPLOAD':
      return { ...state, showFullTextUpload: action.payload }
    case 'SBT_FETCH_ORGANIZATIONS_SUCCESS':
      return { ...state, allOrganizations: action.payload }
    case 'FETCH_SBT_BEGIN':
    case 'FETCH_LAWREPORT_EDIT_BEGIN':
      return { ...defaultState, allOrganizations: state.allOrganizations, allLawPlaces: state.allLawPlaces };
    case 'FETCH_SBT_SUCCESS':
      let organizations = action.payload.organizations;

      for (let i = organizations.length; i < 10; i++) {
        organizations.push('');
      }

      return {
        ...state,
        showFullTextUpload: action.payload.fullTextAttachments.length === 0,
        loading: false,
        publishedOnLoad: action.payload.published,
        ...action.payload,
        organizations,
        allLawPlaces: state.allLawPlaces
      };

    case 'SBT_CHANGE_CATEGORY_PATH':
      state.categoryPaths[action.payload.index][action.payload.attr] = action.payload.value;
      return { ...state, hasChanges: true };
    case 'SBT_CHANGE_CATEGORY_PATH_ID':

      state.categoryPaths[action.payload.index][action.payload.attr + 'Id'] = action.payload.id;
      return { ...state, hasChanges: true };
    case 'SBT_CHANGE_CATEGORY_DATABASE':
      state.categoryPaths[action.payload.index].database = action.payload.value;
      return { ...state, hasChanges: true };
    case 'CHANGE_LAWPLACE':
      let { index, attr, value } = action.payload;
      state.lawPlaces[index][attr] = value;
      return { ...state, hasChanges: true };
    case 'EDIT_SBT':
      let result = { ...state, hasChanges: true };
      result[action.payload.attr] = action.payload.value;
      return result;
    case 'SAVE_SBT_BEGIN':
      return { ...state, loading: true }
    case 'SAVE_SBT_SUCCESS':

      if (action.payload.categoryNotificationsCreated > 0 || action.payload.lawPlaceNotificationsCreated > 0) {
        alert('Följande bevakningsnotiser har skapats:\n\n' + action.payload.categoryNotificationsCreated + ' under tema\n' + action.payload.lawPlaceNotificationsCreated + ' under lagrum\n' + action.payload.emailsSent + ' e-post har skickats');
      }

      return { ...state, publishedOnLoad: state.published, loading: false }
    case 'SBT_DELETE_CATEGORY_PATH':
      let p = action.payload.index;
      return { ...state, categoryPaths: [...state.categoryPaths.slice(0, p), ...state.categoryPaths.slice(p + 1)], hasChanges: true };
    case 'SBT_CLEAR_CATEGORY_PATH':
      return { ...state, categoryPaths: [], loading: true };
    case 'SBT_SET_CATEGORY_PATHS':
      return { ...state, categoryPaths: action.payload, loading: false };
    case 'SBT_NEW_CATEGORY_PATH':
      let db = state.categoryPaths.length > 0 ? state.categoryPaths[state.categoryPaths.length - 1].database : '';
      return { ...state, categoryPaths: [...state.categoryPaths, { database: db, category1: '', category2: '', category3: '', category4: '' }], hasChanges: true };
    case 'SHOW_NEWLAWPLACEDIALOG':
      return { ...state, showNewLawplaceDialog: true };
    case 'HIDE_NEWLAWPLACEDIALOG':
      return { ...state, showNewLawplaceDialog: false };
    case 'FETCH_SBT_LAWDOCUMENTS_SUCCESS':
      return { ...state, allLawPlaces: action.payload };
    case 'SBT_DELETE_ATTACHMENT_SUCCESS':
      return { ...state, attachments: state.attachments.filter((a) => a.id !== action.payload.id) }
    case 'SBT_CHANGE_ORG':
      let orgs = state.organizations;
      orgs[action.payload.index] = action.payload.value;
      return { ...state, organizations: orgs }
    case 'SBT_FETCH_AUTOCOMPLETE_CATEGORIES_BEGIN':
      return { ...state, autoCompleteCategories: [], filteredAutoCompleteCategories: [] }
    case 'SBT_FETCH_AUTOCOMPLETE_CATEGORIES_SUCCESS':
      let filteredAutoCompleteCategories = action.payload.entries.map(e => e.name);
      return { ...state, filteredAutoCompleteCategories, autoCompleteCategories: action.payload.entries }
    case 'SBT_FILTER_AUTOCOMPLETE_CATEGORIES':
      return { ...state, filteredAutoCompleteCategories: action.payload }
    case 'SBT_DELETE_BEGIN':
      return { ...state, loading: true }
    case 'SBT_DELETE_SUCCESS':

      let shouldReload = document.location.href.indexOf('sokning') > 0;

      if (shouldReload) {
        document.location.reload();
      }
      else {
        document.location.href = '/rattsfall';
      }
      return { ...state }
    case 'SBT_ADD_ATTACHMENT':
      let attachments = [...state.attachments, { name: action.payload.name, id: -1 }]

      return { ...state, attachments };
    case 'SBT_CLEAR_LAWPLACES':
      return { ...state, lawPlaces: [], loading: true };
    case 'SBT_SET_LAWPLACES':
      return { ...state, lawPlaces: action.payload, loading: false };
    case 'ADD_SBT_LAWPLACE':

      let lawPlaces = [...state.lawPlaces];

      for (let i = 0; i < action.payload.count; i++) {
        lawPlaces.push(Object.assign({}, action.payload.lawplace));
      }

      return { ...state, showNewLawplaceDialog: false, lawPlaces };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/sbt/sbtReducers.js